/* paused.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
        <svg viewBox="0 0 20 20" preserveAspectRatio="none">
            <path class="foreground-gl" d="M10,19.87a9.9,9.9,0,1,1,9.9-9.9A9.91,9.91,0,0,1,10,19.87ZM10,1.45A8.52,8.52,0,1,0,18.5,10,8.53,8.53,0,0,0,10,1.45Z" transform="translate(-0.07 -0.06)"/><path class="foreground-gl" d="M7.92,14.55a1.36,1.36,0,0,1-1.36-1.36V7A1.36,1.36,0,1,1,9.28,7v6.17A1.36,1.36,0,0,1,7.92,14.55Z" transform="translate(-0.07 -0.06)"/><path class="foreground-gl" d="M12.23,14.55a1.36,1.36,0,0,1-1.36-1.36V7a1.36,1.36,0,1,1,2.73,0v6.17A1.36,1.36,0,0,1,12.23,14.55Z" transform="translate(-0.07 -0.06)"/>
        </svg>
     `,
};
